export const FILTER_LIST_MOBILE_SECTION = 'filters mobile';
export const FILTER_LIST_DESKTOP_SECTION = 'filters desktop';
export const FILTER_CONTAINER = 'filter container';
